<template>
  <div class="organism sidebar-blog">
    <MoleculesSidebarSubscribe />
    <MoleculesSidebarCategories :molecule="categoriesMolecule" />
    <MoleculesSidebarPopularPosts :molecule="popularPostsMolecule" />
  </div>
</template>

<style>
.sidebar-blog {
  form {
    @apply !px-0;
  }
}
</style>

<script setup>
import { storeToRefs } from "pinia";
const blogPosts = useBlogPosts();
const { blogCategories, popularBlogPosts } = storeToRefs(blogPosts);

const props = defineProps({
  organism: Object,
});

const categoriesMolecule = computed(() => {
  return {
    categories: blogCategories?.value.map((category) => {
      return {
        title: category.name,
        slug: category.slug,
        uri: category.uri,
        count: category.count,
      };
    }),
  };
});

const popularPostsMolecule = computed(() => {
  if (!Array.isArray(popularBlogPosts.value.value)) return [];
  return {
    posts: popularBlogPosts?.value?.value?.map((post) => {
      return {
        title: post?.title,
        category: post?.blogCategories?.nodes?.[0]?.name ?? "",
        uri: post?.uri,
        image: post?.customPostDetails?.thumbnail,
      };
    }),
  };
});
</script>
